export var toolbarMenuRadioGroupWrapperStyles = {
  root: function root() {
    return {};
  }
};
//# sourceMappingURL=toolbarMenuRadioGroupWrapperStyles.js.map
